export default __webpack_public_path__ + "static/media/icon2.01f8bf3e.png";